// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RAMIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RAMIcon" ref={forwardedRef} {...props}>
      <path d="M7 6.75H5.5v3H7z" />
      <path d="M14.5 6.75H13v3h1.5z" />
      <path d="M10.75 6.75h-1.5v3h1.5z" />
      <path d="M3 3.75a1 1 0 0 0-1 1v2.061a.15.15 0 0 0 .078.131c1.04.562 1.04 2.054 0 2.616A.15.15 0 0 0 2 9.688v2.062a1 1 0 0 0 1 1h.75v3.5h12.5v-3.5H17a1 1 0 0 0 1-1V9.689a.15.15 0 0 0-.078-.131c-1.04-.562-1.04-2.054 0-2.616A.15.15 0 0 0 18 6.812V4.75a1 1 0 0 0-1-1zm11.75 9v2h-2.003v-2zm-3.5 0v2H8.747v-2zm-4 0v2h-2v-2zm9.25-1.5h-13v-.9c1.144-1.147 1.144-3.053 0-4.2v-.9h13v.9c-1.144 1.147-1.144 3.053 0 4.2z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RAMIcon = /* @__PURE__ */ Object.assign(RAMIconComponent, {
  displayName: 'RAMIcon',
});
